/**
 * @copyright Microsoft Corporation. All rights reserved.
 */
const flightsSplitter = ';';
const keyValueFlightSplitter = ':';
export function parseFlights(serializedFlights) {
    if (!serializedFlights) {
        return new WorkflowFlights([], new Set(), new Map());
    }
    const flights = serializedFlights.split(flightsSplitter);
    const normalizedFlights = new Set();
    const flightsMap = new Map();
    for (const flight of flights) {
        const trimmedFlight = flight.trim();
        if (trimmedFlight === '') {
            continue;
        }
        normalizedFlights.add(WorkflowFlights.normalizeName(trimmedFlight));
        const [flightName, flightValue] = trimmedFlight.split(keyValueFlightSplitter);
        const normalizedFlightName = WorkflowFlights.normalizeName(flightName);
        if (normalizedFlightName) {
            flightsMap.set(normalizedFlightName, flightValue);
        }
    }
    return new WorkflowFlights(flights, normalizedFlights, flightsMap);
}
export class WorkflowFlights {
    constructor(originalFlights, normalizedFlights, keyValueFlightsMap) {
        this.originalFlights = originalFlights;
        this.normalizedFlights = normalizedFlights;
        this.keyValueFlightsMap = keyValueFlightsMap;
    }
    static normalizeName(name) {
        return name === null || name === void 0 ? void 0 : name.toLowerCase();
    }
    hasFlight(flight) {
        const normalizedName = WorkflowFlights.normalizeName(flight);
        const wholeFlightMatched = this.normalizedFlights.has(normalizedName);
        const flightNameMatched = this.keyValueFlightsMap.has(normalizedName);
        return wholeFlightMatched || flightNameMatched;
    }
    getBooleanValue(flightName, fallbackValue) {
        var _a;
        const normalizedValue = (_a = this.getStringValue(flightName)) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        switch (normalizedValue) {
            case 'true':
                return true;
            case 'false':
                return false;
            default:
                return fallbackValue;
        }
    }
    getIntValue(flightName, fallbackValue) {
        const value = this.getStringValue(flightName);
        const parsed = Number.parseInt(value, 10);
        if (Number.isNaN(parsed)) {
            return fallbackValue;
        }
        return parsed;
    }
    getStringValue(flightName, fallbackValue) {
        var _a;
        return (_a = this.keyValueFlightsMap.get(WorkflowFlights.normalizeName(flightName))) !== null && _a !== void 0 ? _a : fallbackValue;
    }
    getAll() {
        return this.originalFlights;
    }
}
//# sourceMappingURL=workflow-flights.js.map